import cqrsApiService from "@/app/shared/services/cqrsApiService.js";

export default {
  fetchCompaniesByProjectId(projectId, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Get("Drilling/Companies/FindByProjectId", { params : { projectId } }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  fetchEmployeesByCompanyId(companyId, vm) {
    return new Promise((resolve, reject) => {
      return cqrsApiService.Get("Drilling/Employees/FindAll", { params: { companyId } }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  addEmployee(employee, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/Employees/Create", { employee }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  editEmployee(employee, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/Employees/Edit", { employee }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  deleteEmployee(id, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/Employees/Delete", { id }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}